// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-2BtCv";
var _3 = "paper-XR-zR";
export { _1 as "__esModule", _2 as "button", _3 as "paper" }
export default { "__esModule": _1, "button": _2, "paper": _3 }
